/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Api_Errors_Registration_FailedInputs */

const nl_signup_api_errors_registration_failed = /** @type {(inputs: Signup_Api_Errors_Registration_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het registreren is niet gelukt. Controleer of je wachtwoord aan alle eisen voldoet en probeer het opnieuw.`)
};

/**

* @param {Signup_Api_Errors_Registration_FailedInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const signup_api_errors_registration_failed = /** @type {((inputs?: Signup_Api_Errors_Registration_FailedInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Api_Errors_Registration_FailedInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_signup_api_errors_registration_failed(inputs)
});
export { signup_api_errors_registration_failed as "signup.api_errors.registration_failed" }